<template>
    <div class="banner">
        <swiper :options="swiperOption" v-if="bannerList.length > 0">
            <swiper-slide v-for="(item, index) in bannerList" :key="index">
                <a :href="item.redirect" target="_blank" v-if="item.redirect">
                    <img :src="item.img" alt />
                </a>
                <img :src="item.img" alt v-else />
                <div class="banner-title">{{ item.title }}</div>
            </swiper-slide>
            <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
    // 必须引用
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    export default {
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                bannerList: [],
                swiperOption: {
                    slidesPerView: 1,
                    loop: true,
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                }
            };
        },
        created() {
            this.getBannerList();
        },
        methods: {
            getBannerList() {
                this.httpGet(this.$root.getBanner, {})
                    .then(result => {
                        this.bannerList.push(...result.list);
                        this.loadingCount += 1;
                    })
                    .catch(err => {
                        console.error('getBanner-err', err);
                    });
            },
            goTo(e) {
                if (e && e !== '') {
                    window.location.href = e;
                    console.log('goto');
                }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .banner {
        width: 100%;
        width: 880px;
        height: calc(100% -16px);
        margin: 8px 0;

        img {
            width: 100%;
            height: 364px;
            border-radius: 8px;
        }
    }

    .banner-heading {
        flex-y(center);
        color: #4E81E2;

        h1 {
            max-width: 1084px;
            font-size: 40px;
            font-weight: bold;
            line-height: 52px;
            flex-wrap: wrap;
            margin-bottom: 15px;
            // margin-top: 10px;
            text-align: center;
        }

        h5 {
            max-width: 984px;
            height: 21px;
            font-size: 16px;
            line-height: 21px;
            flex-wrap: wrap;
        }
    }

    .banner-title {
        margin-top: -40px;
        max-width: 1184px;
        height: 40px;
        background: #000;
        opacity: 0.6;
        color: white;
        display: flex;
        align-items: center;
        padding-left: 20px;
    }

    .swiper-pagination {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 20px;
        height: 20px;
        max-width: 1160px;
    }

    >>> .swiper-pagination-bullet {
        background: gray9;
        opacity: 1;
        width: 10px;
        height: 10px;
    }

    >>> .swiper-pagination-bullet-active {
        border-radius: 15px;
        background: white;
    }
</style>
